<template>
    <div class="shipping__method__header">
        <span class="shipping__method__header__title">کوپن تخفیف</span>
    </div>
    <div class="shipping__method__body">
        <div class="shipping__method__body__content">
            <template v-if="this.coupons?.length">
                <div class="input-group">
                    <input type="text" class="form-control" :value="this.text" readonly style="font-size: 13px; color: #2a7048;">
                    <button class="btn btn-danger" @click="remove">حذف کوپن</button>
                </div>
            </template>
            <template v-else>
                <div class="shipping__method__body__description"><p>در صورتی که کوپن تخفیف دارید اینجا وارد کنید.</p></div>
                <div class="input-group" style="width: auto; float: right;">
                    <span class="input-group-text" id="basic-addon1" style="font-size: 12px;">کوپن تخفیف</span>
                    <input type="text" class="form-control" v-model="temp_coupon" @keyup.enter="apply">
                    <button class="btn btn-success" :disabled="!temp_coupon" @click="apply">اعمال</button>
                </div>
                <div class="clearfix"></div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "Coupon",
    props: ['coupon', "coupons"],
    emits: ['update:coupon'],
    data: () => ({
        temp_coupon: '',
    }),
    computed: {
        text() {
            return `کوپن تخفیف ${this.coupons[0].code} با مبلغ ${this.numberFormat(this.coupons[0].applied_amount)} تومان اعمال شد.`
        }
    },
    methods: {
        apply() {
            this.$emit('update:coupon', this.temp_coupon);
        },
        remove() {
            this.temp_coupon = '';
            this.apply();
        }
    }
}
</script>

<style scoped>

</style>
